import React from 'react'
import ProtectedComponent from '../generic/ProtectedComponent'
import { Link } from 'react-router-dom'
import { observer, inject } from 'mobx-react'

const ManagePortalList = inject('uiStore')(observer(props => {
  const { activeItem } = props.uiStore.state.sidebar
  const items = [{
    name: 'Gerenciar Usuários',
    path: '/dashboard/configuracoes/usuarios',
    permission: 'configure_users'
  },{
    name: 'Gerenciar Empresas',
    path: '/dashboard/configuracoes/empresas',
    permission: 'configure_companies'
  },{
    name: 'Gerenciar Grupos',
    path: '/dashboard/configuracoes/grupos',
    permission: 'configure_groups'
  }]
  return (
    items.map(item => {
      const isActive = activeItem === item.name ? 'is-active' : ''
      return (
        <ProtectedComponent key={item.name} permission={item.permission}>
          <li>
            <Link to={item.path} className={isActive} onClick={() => props.uiStore.changeActiveItem(item.name)}>
              {item.name}
            </Link>
          </li>
        </ProtectedComponent>
      )
    })
  )
}))

export default ManagePortalList;



// WEBPACK FOOTER //
// ./src/components/dashboard/ManagePortalList.js